import { buildProduct } from "../../productTile/selectors";
import shouldShowPromoTile from "../../../../../components/Results/__variants__/plp-promo-tile/shouldShowPromoTile";
import { getStoreCode, getFloor } from "../../../config/selectors";
import { getCategoryId } from "../../../category";
import { getPageSize, getOffset } from "../../selectors";

const getIncludePromoTile = state => {
  const storeCode = getStoreCode(state);

  const floor = getFloor(state);

  const categoryId = getCategoryId(state);

  const offset = getOffset(state).lower / getPageSize(state);

  const startOnPage1 = offset === 0;

  const hasPromoTileOnPage1 = shouldShowPromoTile({
    floor,
    storeCode,
    categoryId,
    pages: [{ pageNumber: 1 }]
  });

  return hasPromoTileOnPage1 && startOnPage1;
};

export const getPages = state => {
  const offset = getOffset(state).lower / getPageSize(state);

  const getPageIndex = index => {
    const includePromoTile = getIncludePromoTile(state);

    if (includePromoTile) {
      index++;
    }

    return Math.floor(index / getPageSize(state));
  };

  const getIndexOnThePage = index => index % getPageSize(state);

  return state.search.products.reduce((pages, product, productIndex) => {
    const pageIndex = getPageIndex(productIndex);
    const pageNumber = offset + pageIndex + 1;

    const onPageProductIndex = getIndexOnThePage(productIndex);
    const pageItem = {
      product: buildProduct(
        {
          product
        },
        state
      ),
      onPageProductIndex
    };

    pages[pageIndex] = pages[pageIndex]
      ? {
          ...pages[pageIndex],
          products: [...pages[pageIndex].products, pageItem]
        }
      : {
          products: [pageItem],
          pageNumber
        };

    return pages;
  }, []);
};
